import React, { Component } from "react";
import { Link } from "react-router-dom";
export default class NoPage extends Component {
  render() {
    return (
      <div>
        <h1>404!</h1>
        page not found
        <br />
        <Link to="./">main page</Link>
      </div>
    );
  }
}
